import React from "react";
import { JhText } from "designPackages/textPackage";

const PricingHeader: React.FC = () => {
  return (
    <div className="tw-root flex flex-col items-center justify-center text-center gap-2.5 pb-10">
      <JhText variant="title4" color="foreground" className="w-60 md:w-full">
        Buy more <span className="text-primary">credits</span> from bundles
        below
      </JhText>

      <JhText variant="body1" color="muted-foreground">
        Select a plan that fits your hiring requirements
      </JhText>
    </div>
  );
};

export default PricingHeader;
